export enum typeStatusEnum {
  LIBERADO = "Liberado",
  BLOQUEADO = "Bloqueado",
  LIB = "Liberado",
  BL = "Bloqueado",
}
